module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/privacy-findx2.189fb916.png";